/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The TankTypeOption model module.
* @module model/TankTypeOption
* @version 2020-12-7
*/
export default class TankTypeOption {
    /**
    * Constructs a new <code>TankTypeOption</code>.
    * タンクタイプ
    * @alias module:model/TankTypeOption
    * @class
    * @param id {Number} タンクタイプID
    * @param name {String} タンクタイプ名
    * @param maxVolume {Number} 最大容量
    * @param tankSize {Array.<Number>} タンクサイズ (w, d, h)
    * @param tankTypeCode {String} タンクタイプコード
    */

    constructor(id, name, maxVolume, tankSize, tankTypeCode) {
        
        
        this['id'] = id;
        this['name'] = name;
        this['maxVolume'] = maxVolume;
        this['tankSize'] = tankSize;
        this['tankTypeCode'] = tankTypeCode;
        
    }

    /**
    * Constructs a <code>TankTypeOption</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/TankTypeOption} obj Optional instance to populate.
    * @return {module:model/TankTypeOption} The populated <code>TankTypeOption</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new TankTypeOption();
                        
            
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('maxVolume')) {
                obj['maxVolume'] = ApiClient.convertToType(data['maxVolume'], 'Number');
            }
            if (data.hasOwnProperty('tankSize')) {
                obj['tankSize'] = ApiClient.convertToType(data['tankSize'], ['Number']);
            }
            if (data.hasOwnProperty('tankTypeCode')) {
                obj['tankTypeCode'] = ApiClient.convertToType(data['tankTypeCode'], 'String');
            }
        }
        return obj;
    }

    /**
    * タンクタイプID
    * @member {Number} id
    */
    'id' = undefined;
    /**
    * タンクタイプ名
    * @member {String} name
    */
    'name' = undefined;
    /**
    * 最大容量
    * @member {Number} maxVolume
    */
    'maxVolume' = undefined;
    /**
    * タンクサイズ (w, d, h)
    * @member {Array.<Number>} tankSize
    */
    'tankSize' = undefined;
    /**
    * タンクタイプコード
    * @member {String} tankTypeCode
    */
    'tankTypeCode' = undefined;




}
